"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconGift = void 0;
var React = __importStar(require("react"));
var IconGift = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M21,10.5892 C21,10.8152 20.776,10.9982 20.5,10.9982 L14,10.9982 L14,6.9982 L20.5,6.9982 C20.776,6.9982 21,7.1822 21,7.4072 L21,10.5892 Z M20,20.4982 C20,20.7742 19.776,20.9982 19.5,20.9982 L14,20.9982 L14,11.9982 L20,11.9982 L20,20.4982 Z M11,20.9982 L11,6.9982 L11.993,6.9982 L12,6.9982 L12.007,6.9982 L13,6.9982 L13,20.9982 L11,20.9982 Z M4,20.4982 L4,11.9982 L10,11.9982 L10,20.9982 L4.5,20.9982 C4.224,20.9982 4,20.7742 4,20.4982 L4,20.4982 Z M3,7.4072 C3,7.1822 3.224,6.9982 3.5,6.9982 L10,6.9982 L10,10.9982 L3.5,10.9982 C3.224,10.9982 3,10.8152 3,10.5892 L3,7.4072 Z M6.064,3.6232 C6.17,3.3072 6.356,2.9972 6.896,2.9972 C6.983,2.9972 7.081,3.0062 7.188,3.0242 C8.638,3.2612 10.609,4.9732 11.272,5.9692 C9.396,5.8532 6.823,5.3952 6.156,4.4502 C5.985,4.2082 5.956,3.9452 6.064,3.6232 L6.064,3.6232 Z M16.812,3.0242 C16.919,3.0062 17.017,2.9972 17.104,2.9972 C17.644,2.9972 17.83,3.3072 17.936,3.6222 C18.044,3.9452 18.015,4.2082 17.844,4.4502 C17.178,5.3932 14.605,5.8522 12.728,5.9692 C13.391,4.9732 15.362,3.2612 16.812,3.0242 L16.812,3.0242 Z M20.5,5.9982 L17.386,5.9982 C17.922,5.7442 18.377,5.4292 18.66,5.0282 C19.017,4.5242 19.094,3.9282 18.883,3.3032 C18.551,2.3202 17.733,1.8612 16.65,2.0362 C15.122,2.2872 12.964,3.8972 12,5.2802 C11.036,3.8972 8.878,2.2872 7.35,2.0362 C6.261,1.8632 5.448,2.3202 5.117,3.3042 C4.906,3.9282 4.983,4.5242 5.34,5.0282 C5.623,5.4292 6.078,5.7442 6.614,5.9982 L3.5,5.9982 C2.673,5.9982 2,6.6302 2,7.4072 L2,10.5892 C2,11.2002 2.419,11.7172 3,11.9112 L3,20.4982 C3,21.3252 3.673,21.9982 4.5,21.9982 L10.5,21.9982 L13.5,21.9982 L19.5,21.9982 C20.327,21.9982 21,21.3252 21,20.4982 L21,11.9112 C21.581,11.7172 22,11.2002 22,10.5892 L22,7.4072 C22,6.6302 21.327,5.9982 20.5,5.9982 L20.5,5.9982 Z" }))); };
exports.IconGift = IconGift;
exports.IconGift.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconGift;
